import { render } from "./LinkWidget.vue?vue&type=template&id=3ec2122a"
import script from "./LinkWidget.vue?vue&type=script&lang=js"
export * from "./LinkWidget.vue?vue&type=script&lang=js"

import "./LinkWidget.vue?vue&type=style&index=0&id=3ec2122a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__